import * as React from 'react';
import { Droppable } from 'react-beautiful-dnd';

import palette from 'ui/theme/palette';

interface Props {
  id: string;
  type: string;
  dataCy?: string;
  children?: React.ReactNode;
  /**
   * Wraps the items AND the drag placeholder together. Anything drawn around the list has to go
   * here rather than around <Drop>'s children, or the placeholder reserves its space outside the
   * wrapper and the list visibly collapses mid-drag.
   */
  renderContainer?: (content: React.ReactNode) => React.ReactNode;
  /**
   * Rendered inside the droppable but outside `renderContainer`. Keep any always-present content
   * (e.g. an "add" link) here so an empty list still has height to drop onto.
   */
  footer?: React.ReactNode;
}

export const Drop: React.FC<Props> = (props) => {
  const getListStyle = (isDraggingOver: boolean) => ({
    background: isDraggingOver ? palette.info.screen : 'transparent',
    width: '100%'
  });

  return (
    <Droppable droppableId={props.id} type={props.type}>
      {(droppableProvided, droppableSnapshot) => (
        <div
          {...droppableProvided.droppableProps}
          ref={droppableProvided.innerRef}
          style={getListStyle(droppableSnapshot.isDraggingOver)}
          data-cy={props.dataCy}
        >
          {props.renderContainer ? (
            props.renderContainer(
              <>
                {props.children}
                {droppableProvided.placeholder}
              </>
            )
          ) : (
            <>
              {props.children}
              {droppableProvided.placeholder}
            </>
          )}
          {props.footer}
        </div>
      )}
    </Droppable>
  );
};
